const Testimonial = () => {
  return (
    <>
      {/* <div className="pt-6 px-4">
        <div className="flex flex-wrap justify-center -mx-4">
          <div className="w-full px-4 text-center">
            <span className="inline-block px-2 py-1 text-xs font-bold uppercase text-emerald-500 bg-emerald-200 rounded mr-1">
              Testimonials
            </span>
            <h2 className="mt-3 mb-1 text-4xl font-bold text-gray-800">
              They've been or not with you
            </h2>
            <p className="mt-2 mb-4 text-xl leading-relaxed text-gray-500">
              It's your life, and there are a lot of people with you, but this
              doesn't mean that everything is ok, it can be anyhow. You stay
              with your friends and nothing matters anymore.
            </p>
          </div>
        </div>
      </div> */}

      <div className="py-12">
        <div className="flex flex-wrap -mx-4 justify-center">
          <div className="relative w-full overflow-hidden">
            <div className="relative w-full transition-all duration-500 ease-in-out">
              <div className="container mx-auto px-4">
                <div className="flex flex-wrap -mx-4">
                  <div className="w-full md:w-5/12 px-4 py-12 ml-auto">
                    <div className="p-6">
                      <img
                        className="w-full rounded-lg shadow-xl transform"
                        src="/images/aboutus.jpg"
                        alt="..."
                      />
                    </div>
                  </div>

                  <div className="w-full md:w-5/12 px-4 pt-12 mr-auto flex items-center">
                    <div className="p-4 pt-6 md:p-0">
                      <h2 className="text-2xl font-bold mt-0 mb-2">
                        Bijender K.
                      </h2>
                      <p className="mt-3 text-lg leading-relaxed text-gray-500">
                        I am an enthusiastic volunteer open to contributing his
                        expertise across a range of impactful sectors, including
                        Education, Science & Technology, Social Services, and
                        Veteran Support. With a strong background in Digital
                        Marketing and Digital Strategy, I am a offers valuable
                        skills to organizations aiming to expand their reach and
                        optimize their digital presence. Based in North America
                        and available in hybrid settings, he is committed to
                        making a meaningful difference through strategic,
                        tech-driven solutions.
                      </p>

                      <ul className="mt-6 list-none">
                        <li className="py-2">
                          <div className="flex items-center">
                            <span className="inline-flex items-center justify-center w-8 h-8 text-sm text-pink-500 bg-pink-200 rounded-full mr-3">
                              <i className="fas fa-atom"></i>
                            </span>
                            <h6 className="text-md text-gray-500">
                              Chief Executive Officer at TTM4U
                            </h6>
                          </div>
                        </li>
                        <li className="py-2">
                          <div className="flex items-center">
                            <span className="inline-flex items-center justify-center w-8 h-8 text-sm text-emerald-500 bg-emerald-200 rounded-full mr-3">
                              <i className="fas fa-running"></i>
                            </span>
                            <h6 className="text-md text-gray-500">
                              Urban city exploration
                            </h6>
                          </div>
                        </li>
                        <li className="py-2">
                          <div className="flex items-center">
                            <span className="inline-flex items-center justify-center w-8 h-8 text-sm text-blue-500 bg-blue-200 rounded-full mr-3">
                              <i className="fab fa-facebook"></i>
                            </span>
                            <h6 className="text-md text-gray-500">
                              Active on Facebook since 2015
                            </h6>
                          </div>
                        </li>
                      </ul>

                      <div className="py-6 pl-12 text-left">
                        <a
                          href="javascript:;"
                          className="inline-block mr-2 text-white bg-blue-400 border border-blue-400 hover:shadow-lg active:bg-blue-500 rounded-md px-6 py-2 text-sm font-bold uppercase transition-all duration-150"
                        >
                          <i className="fab fa-twitter"></i>
                        </a>
                        <a
                          href="javascript:;"
                          className="inline-block mr-2 text-white bg-blue-600 border border-blue-600 hover:shadow-lg active:bg-blue-700 rounded-md px-6 py-2 text-sm font-bold uppercase transition-all duration-150"
                        >
                          <i className="fab fa-facebook"></i>
                        </a>
                        <a
                          href="javascript:;"
                          className="inline-block mr-2 text-white bg-pink-400 border border-pink-400 hover:shadow-lg active:bg-pink-500 rounded-md px-6 py-2 text-sm font-bold uppercase transition-all duration-150"
                        >
                          <i className="fab fa-dribbble"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative w-full -mt-12">
            <a
              href="javascript:;"
              className="absolute top-0 bottom-0 left-[90%] w-[5%] flex items-center justify-center text-white opacity-50 hover:opacity-100 transition-opacity duration-150"
            >
              <i className="text-blue-500 fas fa-chevron-left"></i>
              <span className="sr-only">Previous</span>
            </a>
            <a
              href="javascript:;"
              className="absolute top-0 bottom-0 right-0 w-[5%] flex items-center justify-center text-white opacity-50 hover:opacity-100 transition-opacity duration-150"
            >
              <i className="text-blue-500 fas fa-chevron-right"></i>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
export default Testimonial;
